import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AlertsPage, { getDefaultPageUI } from "components/pages/AlertsPage";

export default function CaptureTypeDDOpen(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "addEditAlertWidget", "alertTypeSelect", "isActive" ], true)
    .submit();

    return <AlertsPage ui={ ui } />
}